import _ from 'lodash';

import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { AuthState } from './types';

/**
 * Getters
 *
 * Vuex allows us to define "getters" in the store.
 * - You can think of them as computed properties for stores.
 * - Like computed properties, a getter's result is cached based on its dependencies,
 *   and will only re-evaluate when some of its dependencies have changed.
 */
export const getters: GetterTree<AuthState, RootState> = {

   /**
    * @param {AuthState} state 
    * @returns void
    */
   fullName: (state: AuthState) => !_.isEmpty(state.user) ? state.user.name : '',

   /**
    * Retrieve cognito user
    * 
    * @param {AuthState} state 
    * @returns void
    */
   cognitoUser: (state: AuthState) => state.cognitoUser,

   /**
    * Check if signed in
    * 
    * @param {AuthState} state 
    * @returns void
    */
   signedIn: (state: AuthState) => state.cognitoUser !== null && state.cognitoUser.Username != '',

   /** 
    * @param {AuthState} state 
    * @returns void
    */
   email: (state: AuthState) => _.get(state.cognitoUser, 'attributes.email', ''),

   /**
    * Retrieves the users device key
    * 
    * @param {AuthState} state 
    * @returns void
    */
   deviceKey: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload.device_key', ''),

   /**
    * 
    * @param {AuthState} state 
    * @returns void
    */
   groups: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []),

   /**
    * Is user an Administrator?
    * 
    * @param {AuthState} state 
    * @returns void
    */
   isAdministrator: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []).includes('Administrators'),

   /**
    * Is user a SysAdmin?
    * 
    * @param {AuthState} state 
    * @returns void
    */
   isSysAdmin: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []).includes('SysAdmin'),

   /**
   * Is user a Customer
   * 
   * @param {AuthState} state 
   * @returns void
   */
   isCustomer: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []).includes('Customers'),

   /**
   * Is user a CustomerAdministrator
   * 
   * @param {AuthState} state 
   * @returns void
   */
   isCustomerAdmin: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []).includes('CustomerAdministrators'),

   /**
   * Is user a BranchAdministrator
   * 
   * @param {AuthState} state 
   * @returns void
   */
   isBranchAdmin: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []).includes('BranchAdministrators'),

   /**
    * Client id attribute of loggedin cognito user
    * 
    * @param {AuthState} state 
    * @returns void
    */
   companyId: (state: AuthState) => _.get(state.cognitoUser, 'attributes["custom:client_id"]', ''),

   /**
    * User id attribute of loggedin cognito user
    * 
    * @param {AuthState} state 
    * @returns void
    */
   userId: (state: AuthState) => _.get(state.cognitoUser, 'attributes["custom:user_id"]', ''),
   /**
   * Is user a BaseUser
   * 
   * @param {AuthState} state 
   * @returns void
   */
    isBaseUser: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []).includes('BaseUser'),
   /**
   * Is user a AdvanceUser
   * 
   * @param {AuthState} state 
   * @returns void
   */
   isAdvanceUser: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []).includes('AdvanceUser'),
   /**
   * Is user a Inspector
   * 
   * @param {AuthState} state 
   * @returns void
   */
   isInspector: (state: AuthState) => _.get(state.cognitoUser, 'signInUserSession.accessToken.payload["cognito:groups"]', []).includes('Inspector'),
};
